// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { mvpApiCreateNewPlanogramGroup, mvpApiCreateNewPlanograms, mvpApiCreateNewProducts, mvpApiCreateNewStorePlanogram, mvpApiCreateNewSuppliers, mvpApiCreateProductIssue, mvpApiCreateStoreSnapshot, mvpApiCwIngestAttachImage, mvpApiCwIngestCommit, mvpApiCwIngestCommitAll, mvpApiCwIngestLatest, mvpApiCwIngestLatestItems, mvpApiCwIngestRefresh, mvpApiCwIngestUnmatchedSuppliers, mvpApiFieldAudit, mvpApiGetPlanogram, mvpApiGetPlanogramGroup, mvpApiGetPlanogramProduct, mvpApiGetPlanogramSummary, mvpApiGetProduct, mvpApiGetRetailer, mvpApiGetStore, mvpApiGetStorePlanogram, mvpApiKrogerIngestBatch, mvpApiKrogerIngestBatches, mvpApiKrogerIngestBatchItems, mvpApiKrogerIngestCommit, mvpApiKrogerIngestDeleteBatch, mvpApiKrogerIngestRebuildBatch, mvpApiKrogerIngestUpdateBatch, mvpApiKrogerIngestUpload, mvpApiKrogerProductIngestCommit, mvpApiKrogerProductIngestCommitAll, mvpApiKrogerProductIngestLatest, mvpApiKrogerProductIngestLatestItems, mvpApiKrogerProductIngestRefresh, mvpApiListAllPlanogramProducts, mvpApiListPlanogramGroupCounts, mvpApiListPlanogramGroups, mvpApiListPlanogramGroupsWithMissingProductImageCount, mvpApiListPlanograms, mvpApiListProductImages, mvpApiListProducts, mvpApiListRetailers, mvpApiListStorePlanograms, mvpApiListStores, mvpApiListSuppliers, mvpApiListUniquePlanogramDescriptions, mvpApiListUniquePlanogramGroupNames, mvpApiRegenerateComposites, mvpApiSearchProducts, mvpApiUpdatePlanogram, mvpApiUpdatePlanogramGroup, mvpApiUpdateProduct, mvpApiUpdateStorePlanogram, mvpApiUpdateSupplier, mvpApiUploadPlanogramImage, mvpApiUploadProductImage, type Options } from '../sdk.gen';
import type { MvpApiCreateNewPlanogramGroupData, MvpApiCreateNewPlanogramGroupResponse, MvpApiCreateNewPlanogramsData, MvpApiCreateNewProductsData, MvpApiCreateNewProductsResponse, MvpApiCreateNewStorePlanogramData, MvpApiCreateNewStorePlanogramResponse, MvpApiCreateNewSuppliersData, MvpApiCreateNewSuppliersResponse, MvpApiCreateProductIssueData, MvpApiCreateProductIssueResponse, MvpApiCreateStoreSnapshotData, MvpApiCwIngestAttachImageData, MvpApiCwIngestAttachImageResponse, MvpApiCwIngestCommitAllData, MvpApiCwIngestCommitAllResponse, MvpApiCwIngestCommitData, MvpApiCwIngestCommitResponse, MvpApiCwIngestLatestData, MvpApiCwIngestLatestItemsData, MvpApiCwIngestLatestItemsResponse, MvpApiCwIngestLatestResponse, MvpApiCwIngestRefreshData, MvpApiCwIngestRefreshResponse, MvpApiCwIngestUnmatchedSuppliersData, MvpApiCwIngestUnmatchedSuppliersResponse, MvpApiFieldAuditData, MvpApiFieldAuditResponse, MvpApiGetPlanogramData, MvpApiGetPlanogramGroupData, MvpApiGetPlanogramGroupResponse, MvpApiGetPlanogramProductData, MvpApiGetPlanogramProductResponse, MvpApiGetPlanogramResponse, MvpApiGetPlanogramSummaryData, MvpApiGetPlanogramSummaryResponse, MvpApiGetProductData, MvpApiGetProductResponse, MvpApiGetRetailerData, MvpApiGetRetailerResponse, MvpApiGetStoreData, MvpApiGetStorePlanogramData, MvpApiGetStorePlanogramResponse, MvpApiGetStoreResponse, MvpApiKrogerIngestBatchData, MvpApiKrogerIngestBatchesData, MvpApiKrogerIngestBatchesResponse, MvpApiKrogerIngestBatchItemsData, MvpApiKrogerIngestBatchItemsResponse, MvpApiKrogerIngestBatchResponse, MvpApiKrogerIngestCommitData, MvpApiKrogerIngestCommitResponse, MvpApiKrogerIngestDeleteBatchData, MvpApiKrogerIngestDeleteBatchResponse, MvpApiKrogerIngestRebuildBatchData, MvpApiKrogerIngestRebuildBatchResponse, MvpApiKrogerIngestUpdateBatchData, MvpApiKrogerIngestUpdateBatchResponse, MvpApiKrogerIngestUploadData, MvpApiKrogerIngestUploadResponse, MvpApiKrogerProductIngestCommitAllData, MvpApiKrogerProductIngestCommitAllResponse, MvpApiKrogerProductIngestCommitData, MvpApiKrogerProductIngestCommitResponse, MvpApiKrogerProductIngestLatestData, MvpApiKrogerProductIngestLatestItemsData, MvpApiKrogerProductIngestLatestItemsResponse, MvpApiKrogerProductIngestLatestResponse, MvpApiKrogerProductIngestRefreshData, MvpApiKrogerProductIngestRefreshResponse, MvpApiListAllPlanogramProductsData, MvpApiListAllPlanogramProductsResponse, MvpApiListPlanogramGroupCountsData, MvpApiListPlanogramGroupCountsResponse, MvpApiListPlanogramGroupsData, MvpApiListPlanogramGroupsResponse, MvpApiListPlanogramGroupsWithMissingProductImageCountData, MvpApiListPlanogramGroupsWithMissingProductImageCountResponse, MvpApiListPlanogramsData, MvpApiListPlanogramsResponse, MvpApiListProductImagesData, MvpApiListProductImagesResponse, MvpApiListProductsData, MvpApiListProductsResponse, MvpApiListRetailersData, MvpApiListRetailersResponse, MvpApiListStorePlanogramsData, MvpApiListStorePlanogramsResponse, MvpApiListStoresData, MvpApiListStoresResponse, MvpApiListSuppliersData, MvpApiListSuppliersResponse, MvpApiListUniquePlanogramDescriptionsData, MvpApiListUniquePlanogramDescriptionsResponse, MvpApiListUniquePlanogramGroupNamesData, MvpApiListUniquePlanogramGroupNamesResponse, MvpApiRegenerateCompositesData, MvpApiRegenerateCompositesResponse, MvpApiSearchProductsData, MvpApiSearchProductsResponse, MvpApiUpdatePlanogramData, MvpApiUpdatePlanogramGroupData, MvpApiUpdatePlanogramGroupResponse, MvpApiUpdatePlanogramResponse, MvpApiUpdateProductData, MvpApiUpdateProductResponse, MvpApiUpdateStorePlanogramData, MvpApiUpdateStorePlanogramResponse, MvpApiUpdateSupplierData, MvpApiUpdateSupplierResponse, MvpApiUploadPlanogramImageData, MvpApiUploadProductImageData, MvpApiUploadProductImageResponse } from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const mvpApiListProductsQueryKey = (options?: Options<MvpApiListProductsData>) => createQueryKey('mvpApiListProducts', options);

/**
 * List Products
 */
export const mvpApiListProductsOptions = (options?: Options<MvpApiListProductsData>) => queryOptions<MvpApiListProductsResponse, DefaultError, MvpApiListProductsResponse, ReturnType<typeof mvpApiListProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListProductsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const mvpApiListProductsInfiniteQueryKey = (options?: Options<MvpApiListProductsData>): QueryKey<Options<MvpApiListProductsData>> => createQueryKey('mvpApiListProducts', options, true);

/**
 * List Products
 */
export const mvpApiListProductsInfiniteOptions = (options?: Options<MvpApiListProductsData>) => infiniteQueryOptions<MvpApiListProductsResponse, DefaultError, InfiniteData<MvpApiListProductsResponse>, QueryKey<Options<MvpApiListProductsData>>, number | Pick<QueryKey<Options<MvpApiListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListProductsInfiniteQueryKey(options)
});

/**
 * Create New Products
 */
export const mvpApiCreateNewProductsMutation = (options?: Partial<Options<MvpApiCreateNewProductsData>>): UseMutationOptions<MvpApiCreateNewProductsResponse, DefaultError, Options<MvpApiCreateNewProductsData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewProductsResponse, DefaultError, Options<MvpApiCreateNewProductsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateNewProducts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiFieldAuditQueryKey = (options: Options<MvpApiFieldAuditData>) => createQueryKey('mvpApiFieldAudit', options);

/**
 * Field Audit
 */
export const mvpApiFieldAuditOptions = (options: Options<MvpApiFieldAuditData>) => queryOptions<MvpApiFieldAuditResponse, DefaultError, MvpApiFieldAuditResponse, ReturnType<typeof mvpApiFieldAuditQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiFieldAudit({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiFieldAuditQueryKey(options)
});

export const mvpApiGetProductQueryKey = (options: Options<MvpApiGetProductData>) => createQueryKey('mvpApiGetProduct', options);

/**
 * Get Product
 */
export const mvpApiGetProductOptions = (options: Options<MvpApiGetProductData>) => queryOptions<MvpApiGetProductResponse, DefaultError, MvpApiGetProductResponse, ReturnType<typeof mvpApiGetProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetProductQueryKey(options)
});

/**
 * Update Product
 */
export const mvpApiUpdateProductMutation = (options?: Partial<Options<MvpApiUpdateProductData>>): UseMutationOptions<MvpApiUpdateProductResponse, DefaultError, Options<MvpApiUpdateProductData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateProductResponse, DefaultError, Options<MvpApiUpdateProductData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateProduct({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiSearchProductsQueryKey = (options?: Options<MvpApiSearchProductsData>) => createQueryKey('mvpApiSearchProducts', options);

/**
 * Search Products
 */
export const mvpApiSearchProductsOptions = (options?: Options<MvpApiSearchProductsData>) => queryOptions<MvpApiSearchProductsResponse, DefaultError, MvpApiSearchProductsResponse, ReturnType<typeof mvpApiSearchProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiSearchProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiSearchProductsQueryKey(options)
});

export const mvpApiSearchProductsInfiniteQueryKey = (options?: Options<MvpApiSearchProductsData>): QueryKey<Options<MvpApiSearchProductsData>> => createQueryKey('mvpApiSearchProducts', options, true);

/**
 * Search Products
 */
export const mvpApiSearchProductsInfiniteOptions = (options?: Options<MvpApiSearchProductsData>) => infiniteQueryOptions<MvpApiSearchProductsResponse, DefaultError, InfiniteData<MvpApiSearchProductsResponse>, QueryKey<Options<MvpApiSearchProductsData>>, number | Pick<QueryKey<Options<MvpApiSearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiSearchProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiSearchProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiSearchProductsInfiniteQueryKey(options)
});

/**
 * Upload Product Image
 */
export const mvpApiUploadProductImageMutation = (options?: Partial<Options<MvpApiUploadProductImageData>>): UseMutationOptions<MvpApiUploadProductImageResponse, DefaultError, Options<MvpApiUploadProductImageData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUploadProductImageResponse, DefaultError, Options<MvpApiUploadProductImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUploadProductImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cw Ingest Refresh
 *
 * Kick off a background build of the newest Chemist Warehouse product feed.
 *
 * Creates a pending CWH ProductIngestBatch and dispatches a Taskhawk task to pull the
 * latest Product_Metadata drop, filter and reconcile it, and persist the
 * proposal. Returns immediately; poll GET /products/cw-ingest/latest for status.
 */
export const mvpApiCwIngestRefreshMutation = (options?: Partial<Options<MvpApiCwIngestRefreshData>>): UseMutationOptions<MvpApiCwIngestRefreshResponse, DefaultError, Options<MvpApiCwIngestRefreshData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCwIngestRefreshResponse, DefaultError, Options<MvpApiCwIngestRefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCwIngestRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiCwIngestLatestQueryKey = (options?: Options<MvpApiCwIngestLatestData>) => createQueryKey('mvpApiCwIngestLatest', options);

/**
 * Cw Ingest Latest
 *
 * The most recent ingest batch (status + summary counts), or null if none.
 */
export const mvpApiCwIngestLatestOptions = (options?: Options<MvpApiCwIngestLatestData>) => queryOptions<MvpApiCwIngestLatestResponse, DefaultError, MvpApiCwIngestLatestResponse, ReturnType<typeof mvpApiCwIngestLatestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiCwIngestLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiCwIngestLatestQueryKey(options)
});

export const mvpApiCwIngestLatestItemsQueryKey = (options?: Options<MvpApiCwIngestLatestItemsData>) => createQueryKey('mvpApiCwIngestLatestItems', options);

/**
 * Cw Ingest Latest Items
 *
 * Paged rows of the latest batch — filter by kind/action/has_upc/has_lockie_plu/
 * supplier_matched.
 */
export const mvpApiCwIngestLatestItemsOptions = (options?: Options<MvpApiCwIngestLatestItemsData>) => queryOptions<MvpApiCwIngestLatestItemsResponse, DefaultError, MvpApiCwIngestLatestItemsResponse, ReturnType<typeof mvpApiCwIngestLatestItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiCwIngestLatestItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiCwIngestLatestItemsQueryKey(options)
});

export const mvpApiCwIngestLatestItemsInfiniteQueryKey = (options?: Options<MvpApiCwIngestLatestItemsData>): QueryKey<Options<MvpApiCwIngestLatestItemsData>> => createQueryKey('mvpApiCwIngestLatestItems', options, true);

/**
 * Cw Ingest Latest Items
 *
 * Paged rows of the latest batch — filter by kind/action/has_upc/has_lockie_plu/
 * supplier_matched.
 */
export const mvpApiCwIngestLatestItemsInfiniteOptions = (options?: Options<MvpApiCwIngestLatestItemsData>) => infiniteQueryOptions<MvpApiCwIngestLatestItemsResponse, DefaultError, InfiniteData<MvpApiCwIngestLatestItemsResponse>, QueryKey<Options<MvpApiCwIngestLatestItemsData>>, number | Pick<QueryKey<Options<MvpApiCwIngestLatestItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiCwIngestLatestItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiCwIngestLatestItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiCwIngestLatestItemsInfiniteQueryKey(options)
});

/**
 * Cw Ingest Commit
 *
 * Apply the reviewed items to Products: creates and updates, resolving each
 * supplier by explicit choice or manufacturer match (never auto-creating one).
 * Each item commits independently; the response reports per-item results.
 */
export const mvpApiCwIngestCommitMutation = (options?: Partial<Options<MvpApiCwIngestCommitData>>): UseMutationOptions<MvpApiCwIngestCommitResponse, DefaultError, Options<MvpApiCwIngestCommitData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCwIngestCommitResponse, DefaultError, Options<MvpApiCwIngestCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCwIngestCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cw Ingest Commit All
 *
 * Commit every uncommitted row matching a filter, in the background.
 *
 * The per-item endpoint can't carry a whole-feed sweep: adding a metadata key
 * turns nearly every existing CWH product into a changed update (~50k rows),
 * which is a thousand pages of 50-row selection. This takes the reviewer's
 * current filter instead, then a self-chunking Taskhawk task works through it.
 * Returns immediately with the matched count; poll GET /products/cw-ingest/latest
 * for commit_status / commit_progress.
 */
export const mvpApiCwIngestCommitAllMutation = (options?: Partial<Options<MvpApiCwIngestCommitAllData>>): UseMutationOptions<MvpApiCwIngestCommitAllResponse, DefaultError, Options<MvpApiCwIngestCommitAllData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCwIngestCommitAllResponse, DefaultError, Options<MvpApiCwIngestCommitAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCwIngestCommitAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Cw Ingest Attach Image
 *
 * Resolve a just-created product's CW image by chem_id and store it, server-side
 * because the CW CDN blocks cross-origin browser fetches. The frontend calls this
 * once per created product to drive its attach-progress display.
 *
 * All the CW-specific work lives in mvp.cw_image so this stopgap can be removed as
 * a unit. Returns 'attached', 'no_image' (not in the index / no image), or 'error'.
 */
export const mvpApiCwIngestAttachImageMutation = (options?: Partial<Options<MvpApiCwIngestAttachImageData>>): UseMutationOptions<MvpApiCwIngestAttachImageResponse, DefaultError, Options<MvpApiCwIngestAttachImageData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCwIngestAttachImageResponse, DefaultError, Options<MvpApiCwIngestAttachImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCwIngestAttachImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiCwIngestUnmatchedSuppliersQueryKey = (options?: Options<MvpApiCwIngestUnmatchedSuppliersData>) => createQueryKey('mvpApiCwIngestUnmatchedSuppliers', options);

/**
 * Cw Ingest Unmatched Suppliers
 *
 * Distinct feed manufacturers in the latest batch that don't match an existing
 * supplier (uncommitted candidates), with how many products each affects — the
 * worklist for the Supplier Resolution step.
 */
export const mvpApiCwIngestUnmatchedSuppliersOptions = (options?: Options<MvpApiCwIngestUnmatchedSuppliersData>) => queryOptions<MvpApiCwIngestUnmatchedSuppliersResponse, DefaultError, MvpApiCwIngestUnmatchedSuppliersResponse, ReturnType<typeof mvpApiCwIngestUnmatchedSuppliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiCwIngestUnmatchedSuppliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiCwIngestUnmatchedSuppliersQueryKey(options)
});

/**
 * Kroger Product Ingest Refresh
 *
 * Kick off a background build of the Kroger pilot-store catalog.
 *
 * Returns the pending batch immediately; the build runs as a chain of tasks
 * (~10 min for ~38k rows). Poll GET /products/kroger-ingest/latest for status
 * and build_progress.
 */
export const mvpApiKrogerProductIngestRefreshMutation = (options?: Partial<Options<MvpApiKrogerProductIngestRefreshData>>): UseMutationOptions<MvpApiKrogerProductIngestRefreshResponse, DefaultError, Options<MvpApiKrogerProductIngestRefreshData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerProductIngestRefreshResponse, DefaultError, Options<MvpApiKrogerProductIngestRefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerProductIngestRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiKrogerProductIngestLatestQueryKey = (options?: Options<MvpApiKrogerProductIngestLatestData>) => createQueryKey('mvpApiKrogerProductIngestLatest', options);

/**
 * Kroger Product Ingest Latest
 *
 * The most recent Kroger catalog batch (status, progress, summary), or null.
 */
export const mvpApiKrogerProductIngestLatestOptions = (options?: Options<MvpApiKrogerProductIngestLatestData>) => queryOptions<MvpApiKrogerProductIngestLatestResponse, DefaultError, MvpApiKrogerProductIngestLatestResponse, ReturnType<typeof mvpApiKrogerProductIngestLatestQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiKrogerProductIngestLatest({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerProductIngestLatestQueryKey(options)
});

export const mvpApiKrogerProductIngestLatestItemsQueryKey = (options?: Options<MvpApiKrogerProductIngestLatestItemsData>) => createQueryKey('mvpApiKrogerProductIngestLatestItems', options);

/**
 * Kroger Product Ingest Latest Items
 *
 * Paged rows of the latest Kroger batch — filter by kind/action/image_action/
 * changed/committed; search description, UPC, brand.
 */
export const mvpApiKrogerProductIngestLatestItemsOptions = (options?: Options<MvpApiKrogerProductIngestLatestItemsData>) => queryOptions<MvpApiKrogerProductIngestLatestItemsResponse, DefaultError, MvpApiKrogerProductIngestLatestItemsResponse, ReturnType<typeof mvpApiKrogerProductIngestLatestItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiKrogerProductIngestLatestItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerProductIngestLatestItemsQueryKey(options)
});

export const mvpApiKrogerProductIngestLatestItemsInfiniteQueryKey = (options?: Options<MvpApiKrogerProductIngestLatestItemsData>): QueryKey<Options<MvpApiKrogerProductIngestLatestItemsData>> => createQueryKey('mvpApiKrogerProductIngestLatestItems', options, true);

/**
 * Kroger Product Ingest Latest Items
 *
 * Paged rows of the latest Kroger batch — filter by kind/action/image_action/
 * changed/committed; search description, UPC, brand.
 */
export const mvpApiKrogerProductIngestLatestItemsInfiniteOptions = (options?: Options<MvpApiKrogerProductIngestLatestItemsData>) => infiniteQueryOptions<MvpApiKrogerProductIngestLatestItemsResponse, DefaultError, InfiniteData<MvpApiKrogerProductIngestLatestItemsResponse>, QueryKey<Options<MvpApiKrogerProductIngestLatestItemsData>>, number | Pick<QueryKey<Options<MvpApiKrogerProductIngestLatestItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiKrogerProductIngestLatestItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiKrogerProductIngestLatestItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerProductIngestLatestItemsInfiniteQueryKey(options)
});

/**
 * Kroger Product Ingest Commit
 *
 * Apply the selected rows: create/update the products, then attach any
 * packshot to add or replace. Each row commits independently.
 */
export const mvpApiKrogerProductIngestCommitMutation = (options?: Partial<Options<MvpApiKrogerProductIngestCommitData>>): UseMutationOptions<MvpApiKrogerProductIngestCommitResponse, DefaultError, Options<MvpApiKrogerProductIngestCommitData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerProductIngestCommitResponse, DefaultError, Options<MvpApiKrogerProductIngestCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerProductIngestCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Kroger Product Ingest Commit All
 *
 * Commit every uncommitted row matching a filter, in the background. Poll
 * GET /products/kroger-ingest/latest for commit_status / commit_progress.
 */
export const mvpApiKrogerProductIngestCommitAllMutation = (options?: Partial<Options<MvpApiKrogerProductIngestCommitAllData>>): UseMutationOptions<MvpApiKrogerProductIngestCommitAllResponse, DefaultError, Options<MvpApiKrogerProductIngestCommitAllData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerProductIngestCommitAllResponse, DefaultError, Options<MvpApiKrogerProductIngestCommitAllData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerProductIngestCommitAll({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Kroger Ingest Upload
 *
 * Ingest one or more Kroger planogram files, end to end.
 *
 * Accepts the original .psa or the intermediate .json that kroger-json.py
 * emits. One batch per file — a file is one fixture, and each is parsed,
 * validated and committed on its own. The raw bytes are kept in GCS so a batch
 * can be re-parsed later without a re-upload.
 *
 * Returns immediately, before any parsing. The rest runs in the background and
 * the batch is the only thing to poll: `status` walks pending -> parsing ->
 * ready, then `commit_status` walks idle -> running -> done, with
 * commit_progress carrying the counts and committed_planogram_id the result.
 * Anything that fails validation leaves the batch uncommitted with the reasons
 * in commit_error; nothing partial is ever written. Set KROGER_AUTO_COMMIT to
 * false to stop at `ready` and drive the commit endpoint by hand instead.
 *
 * Local and staging runs have no taskhawk consumer to pick the job up. The
 * ingest_kroger_planograms management command runs the same work in-process
 * there — against a local file, or against a batch this endpoint has staged.
 */
export const mvpApiKrogerIngestUploadMutation = (options?: Partial<Options<MvpApiKrogerIngestUploadData>>): UseMutationOptions<MvpApiKrogerIngestUploadResponse, DefaultError, Options<MvpApiKrogerIngestUploadData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerIngestUploadResponse, DefaultError, Options<MvpApiKrogerIngestUploadData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerIngestUpload({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiKrogerIngestBatchesQueryKey = (options?: Options<MvpApiKrogerIngestBatchesData>) => createQueryKey('mvpApiKrogerIngestBatches', options);

/**
 * Kroger Ingest Batches
 *
 * Staged Kroger ingests, newest first. Unlike CWH's single rolling batch,
 * one accumulates per uploaded .psa.
 */
export const mvpApiKrogerIngestBatchesOptions = (options?: Options<MvpApiKrogerIngestBatchesData>) => queryOptions<MvpApiKrogerIngestBatchesResponse, DefaultError, MvpApiKrogerIngestBatchesResponse, ReturnType<typeof mvpApiKrogerIngestBatchesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiKrogerIngestBatches({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerIngestBatchesQueryKey(options)
});

export const mvpApiKrogerIngestBatchesInfiniteQueryKey = (options?: Options<MvpApiKrogerIngestBatchesData>): QueryKey<Options<MvpApiKrogerIngestBatchesData>> => createQueryKey('mvpApiKrogerIngestBatches', options, true);

/**
 * Kroger Ingest Batches
 *
 * Staged Kroger ingests, newest first. Unlike CWH's single rolling batch,
 * one accumulates per uploaded .psa.
 */
export const mvpApiKrogerIngestBatchesInfiniteOptions = (options?: Options<MvpApiKrogerIngestBatchesData>) => infiniteQueryOptions<MvpApiKrogerIngestBatchesResponse, DefaultError, InfiniteData<MvpApiKrogerIngestBatchesResponse>, QueryKey<Options<MvpApiKrogerIngestBatchesData>>, number | Pick<QueryKey<Options<MvpApiKrogerIngestBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiKrogerIngestBatchesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiKrogerIngestBatches({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerIngestBatchesInfiniteQueryKey(options)
});

/**
 * Kroger Ingest Delete Batch
 *
 * Discard an uncommitted batch. Committed batches are kept as the record of
 * where a planogram came from.
 */
export const mvpApiKrogerIngestDeleteBatchMutation = (options?: Partial<Options<MvpApiKrogerIngestDeleteBatchData>>): UseMutationOptions<MvpApiKrogerIngestDeleteBatchResponse, DefaultError, Options<MvpApiKrogerIngestDeleteBatchData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerIngestDeleteBatchResponse, DefaultError, Options<MvpApiKrogerIngestDeleteBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerIngestDeleteBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiKrogerIngestBatchQueryKey = (options: Options<MvpApiKrogerIngestBatchData>) => createQueryKey('mvpApiKrogerIngestBatch', options);

/**
 * Kroger Ingest Batch
 *
 * One batch: status, summary counts, bay geometry, and unmatched suppliers.
 */
export const mvpApiKrogerIngestBatchOptions = (options: Options<MvpApiKrogerIngestBatchData>) => queryOptions<MvpApiKrogerIngestBatchResponse, DefaultError, MvpApiKrogerIngestBatchResponse, ReturnType<typeof mvpApiKrogerIngestBatchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiKrogerIngestBatch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerIngestBatchQueryKey(options)
});

/**
 * Kroger Ingest Update Batch
 *
 * Set the planogram group, name, or type before committing. The .psa names
 * the fixture but not which planogram group it belongs to.
 */
export const mvpApiKrogerIngestUpdateBatchMutation = (options?: Partial<Options<MvpApiKrogerIngestUpdateBatchData>>): UseMutationOptions<MvpApiKrogerIngestUpdateBatchResponse, DefaultError, Options<MvpApiKrogerIngestUpdateBatchData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerIngestUpdateBatchResponse, DefaultError, Options<MvpApiKrogerIngestUpdateBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerIngestUpdateBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiKrogerIngestBatchItemsQueryKey = (options: Options<MvpApiKrogerIngestBatchItemsData>) => createQueryKey('mvpApiKrogerIngestBatchItems', options);

/**
 * Kroger Ingest Batch Items
 *
 * Paged product rows of a batch — filter by action/has_upc/supplier_matched/
 * committed/changed.
 */
export const mvpApiKrogerIngestBatchItemsOptions = (options: Options<MvpApiKrogerIngestBatchItemsData>) => queryOptions<MvpApiKrogerIngestBatchItemsResponse, DefaultError, MvpApiKrogerIngestBatchItemsResponse, ReturnType<typeof mvpApiKrogerIngestBatchItemsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiKrogerIngestBatchItems({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerIngestBatchItemsQueryKey(options)
});

export const mvpApiKrogerIngestBatchItemsInfiniteQueryKey = (options: Options<MvpApiKrogerIngestBatchItemsData>): QueryKey<Options<MvpApiKrogerIngestBatchItemsData>> => createQueryKey('mvpApiKrogerIngestBatchItems', options, true);

/**
 * Kroger Ingest Batch Items
 *
 * Paged product rows of a batch — filter by action/has_upc/supplier_matched/
 * committed/changed.
 */
export const mvpApiKrogerIngestBatchItemsInfiniteOptions = (options: Options<MvpApiKrogerIngestBatchItemsData>) => infiniteQueryOptions<MvpApiKrogerIngestBatchItemsResponse, DefaultError, InfiniteData<MvpApiKrogerIngestBatchItemsResponse>, QueryKey<Options<MvpApiKrogerIngestBatchItemsData>>, number | Pick<QueryKey<Options<MvpApiKrogerIngestBatchItemsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiKrogerIngestBatchItemsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiKrogerIngestBatchItems({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiKrogerIngestBatchItemsInfiniteQueryKey(options)
});

/**
 * Kroger Ingest Rebuild Batch
 *
 * Re-parse and re-enrich a batch from its stored .psa.
 *
 * For a batch that failed, or whose enrichment came back empty because the
 * Kroger API was down. Replaces the staged rows; refuses once committed.
 */
export const mvpApiKrogerIngestRebuildBatchMutation = (options?: Partial<Options<MvpApiKrogerIngestRebuildBatchData>>): UseMutationOptions<MvpApiKrogerIngestRebuildBatchResponse, DefaultError, Options<MvpApiKrogerIngestRebuildBatchData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerIngestRebuildBatchResponse, DefaultError, Options<MvpApiKrogerIngestRebuildBatchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerIngestRebuildBatch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Kroger Ingest Commit
 *
 * Commit a reviewed batch: write its Products and Suppliers, create the
 * Planogram and its PlanogramProducts, then attach product images.
 *
 * The write is one transaction in a background task — a fixture is committed
 * whole or not at all. Returns immediately with what it will write; poll the
 * batch for commit_status / commit_progress.
 */
export const mvpApiKrogerIngestCommitMutation = (options?: Partial<Options<MvpApiKrogerIngestCommitData>>): UseMutationOptions<MvpApiKrogerIngestCommitResponse, DefaultError, Options<MvpApiKrogerIngestCommitData>> => {
    const mutationOptions: UseMutationOptions<MvpApiKrogerIngestCommitResponse, DefaultError, Options<MvpApiKrogerIngestCommitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiKrogerIngestCommit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListPlanogramsQueryKey = (options?: Options<MvpApiListPlanogramsData>) => createQueryKey('mvpApiListPlanograms', options);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsOptions = (options?: Options<MvpApiListPlanogramsData>) => queryOptions<MvpApiListPlanogramsResponse, DefaultError, MvpApiListPlanogramsResponse, ReturnType<typeof mvpApiListPlanogramsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListPlanograms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramsQueryKey(options)
});

export const mvpApiListPlanogramsInfiniteQueryKey = (options?: Options<MvpApiListPlanogramsData>): QueryKey<Options<MvpApiListPlanogramsData>> => createQueryKey('mvpApiListPlanograms', options, true);

/**
 * List Planograms
 */
export const mvpApiListPlanogramsInfiniteOptions = (options?: Options<MvpApiListPlanogramsData>) => infiniteQueryOptions<MvpApiListPlanogramsResponse, DefaultError, InfiniteData<MvpApiListPlanogramsResponse>, QueryKey<Options<MvpApiListPlanogramsData>>, number | Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListPlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListPlanograms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramsInfiniteQueryKey(options)
});

/**
 * Create New Planograms
 */
export const mvpApiCreateNewPlanogramsMutation = (options?: Partial<Options<MvpApiCreateNewPlanogramsData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateNewPlanogramsData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateNewPlanogramsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateNewPlanograms({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListUniquePlanogramDescriptionsQueryKey = (options?: Options<MvpApiListUniquePlanogramDescriptionsData>) => createQueryKey('mvpApiListUniquePlanogramDescriptions', options);

/**
 * List Unique Planogram Descriptions
 */
export const mvpApiListUniquePlanogramDescriptionsOptions = (options?: Options<MvpApiListUniquePlanogramDescriptionsData>) => queryOptions<MvpApiListUniquePlanogramDescriptionsResponse, DefaultError, MvpApiListUniquePlanogramDescriptionsResponse, ReturnType<typeof mvpApiListUniquePlanogramDescriptionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListUniquePlanogramDescriptions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListUniquePlanogramDescriptionsQueryKey(options)
});

export const mvpApiGetPlanogramQueryKey = (options: Options<MvpApiGetPlanogramData>) => createQueryKey('mvpApiGetPlanogram', options);

/**
 * Get Planogram
 */
export const mvpApiGetPlanogramOptions = (options: Options<MvpApiGetPlanogramData>) => queryOptions<MvpApiGetPlanogramResponse, DefaultError, MvpApiGetPlanogramResponse, ReturnType<typeof mvpApiGetPlanogramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetPlanogram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetPlanogramQueryKey(options)
});

/**
 * Update Planogram
 */
export const mvpApiUpdatePlanogramMutation = (options?: Partial<Options<MvpApiUpdatePlanogramData>>): UseMutationOptions<MvpApiUpdatePlanogramResponse, DefaultError, Options<MvpApiUpdatePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdatePlanogramResponse, DefaultError, Options<MvpApiUpdatePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdatePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetPlanogramSummaryQueryKey = (options: Options<MvpApiGetPlanogramSummaryData>) => createQueryKey('mvpApiGetPlanogramSummary', options);

/**
 * Get Planogram Summary
 */
export const mvpApiGetPlanogramSummaryOptions = (options: Options<MvpApiGetPlanogramSummaryData>) => queryOptions<MvpApiGetPlanogramSummaryResponse, DefaultError, MvpApiGetPlanogramSummaryResponse, ReturnType<typeof mvpApiGetPlanogramSummaryQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetPlanogramSummary({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetPlanogramSummaryQueryKey(options)
});

export const mvpApiGetPlanogramProductQueryKey = (options: Options<MvpApiGetPlanogramProductData>) => createQueryKey('mvpApiGetPlanogramProduct', options);

/**
 * Get Planogram Product
 */
export const mvpApiGetPlanogramProductOptions = (options: Options<MvpApiGetPlanogramProductData>) => queryOptions<MvpApiGetPlanogramProductResponse, DefaultError, MvpApiGetPlanogramProductResponse, ReturnType<typeof mvpApiGetPlanogramProductQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetPlanogramProduct({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetPlanogramProductQueryKey(options)
});

export const mvpApiListAllPlanogramProductsQueryKey = (options?: Options<MvpApiListAllPlanogramProductsData>) => createQueryKey('mvpApiListAllPlanogramProducts', options);

/**
 * List All Planogram Products
 *
 * Flat, paginated PlanogramProduct list. Filter by id(s), planogram, product,
 * or an updated_after/updated_before time window.
 */
export const mvpApiListAllPlanogramProductsOptions = (options?: Options<MvpApiListAllPlanogramProductsData>) => queryOptions<MvpApiListAllPlanogramProductsResponse, DefaultError, MvpApiListAllPlanogramProductsResponse, ReturnType<typeof mvpApiListAllPlanogramProductsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListAllPlanogramProducts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListAllPlanogramProductsQueryKey(options)
});

export const mvpApiListAllPlanogramProductsInfiniteQueryKey = (options?: Options<MvpApiListAllPlanogramProductsData>): QueryKey<Options<MvpApiListAllPlanogramProductsData>> => createQueryKey('mvpApiListAllPlanogramProducts', options, true);

/**
 * List All Planogram Products
 *
 * Flat, paginated PlanogramProduct list. Filter by id(s), planogram, product,
 * or an updated_after/updated_before time window.
 */
export const mvpApiListAllPlanogramProductsInfiniteOptions = (options?: Options<MvpApiListAllPlanogramProductsData>) => infiniteQueryOptions<MvpApiListAllPlanogramProductsResponse, DefaultError, InfiniteData<MvpApiListAllPlanogramProductsResponse>, QueryKey<Options<MvpApiListAllPlanogramProductsData>>, number | Pick<QueryKey<Options<MvpApiListAllPlanogramProductsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListAllPlanogramProductsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListAllPlanogramProducts({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListAllPlanogramProductsInfiniteQueryKey(options)
});

/**
 * Upload Planogram Image
 */
export const mvpApiUploadPlanogramImageMutation = (options?: Partial<Options<MvpApiUploadPlanogramImageData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiUploadPlanogramImageData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiUploadPlanogramImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUploadPlanogramImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Regenerate Composites
 *
 * Completion trigger for background composites (ATL-19).
 *
 * A caller that just finished uploading a batch of product images (bulk
 * "Missing Product Images", the .psa bitmap flow, or a one-off upload) calls
 * this once to re-render the affected planograms — instead of the per-image
 * endpoint firing hundreds of redundant renders. Resolves product_ids to the
 * planograms that place them, unions with planogram_ids, dedups, and dispatches
 * one composite task per planogram. min_image_fraction=0.0: the upload just
 * finished, so render whatever is present rather than gating on readiness.
 */
export const mvpApiRegenerateCompositesMutation = (options?: Partial<Options<MvpApiRegenerateCompositesData>>): UseMutationOptions<MvpApiRegenerateCompositesResponse, DefaultError, Options<MvpApiRegenerateCompositesData>> => {
    const mutationOptions: UseMutationOptions<MvpApiRegenerateCompositesResponse, DefaultError, Options<MvpApiRegenerateCompositesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiRegenerateComposites({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListStorePlanogramsQueryKey = (options?: Options<MvpApiListStorePlanogramsData>) => createQueryKey('mvpApiListStorePlanograms', options);

/**
 * List Store Planograms
 */
export const mvpApiListStorePlanogramsOptions = (options?: Options<MvpApiListStorePlanogramsData>) => queryOptions<MvpApiListStorePlanogramsResponse, DefaultError, MvpApiListStorePlanogramsResponse, ReturnType<typeof mvpApiListStorePlanogramsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListStorePlanograms({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStorePlanogramsQueryKey(options)
});

export const mvpApiListStorePlanogramsInfiniteQueryKey = (options?: Options<MvpApiListStorePlanogramsData>): QueryKey<Options<MvpApiListStorePlanogramsData>> => createQueryKey('mvpApiListStorePlanograms', options, true);

/**
 * List Store Planograms
 */
export const mvpApiListStorePlanogramsInfiniteOptions = (options?: Options<MvpApiListStorePlanogramsData>) => infiniteQueryOptions<MvpApiListStorePlanogramsResponse, DefaultError, InfiniteData<MvpApiListStorePlanogramsResponse>, QueryKey<Options<MvpApiListStorePlanogramsData>>, number | Pick<QueryKey<Options<MvpApiListStorePlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListStorePlanogramsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListStorePlanograms({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStorePlanogramsInfiniteQueryKey(options)
});

/**
 * Create New Store Planogram
 */
export const mvpApiCreateNewStorePlanogramMutation = (options?: Partial<Options<MvpApiCreateNewStorePlanogramData>>): UseMutationOptions<MvpApiCreateNewStorePlanogramResponse, DefaultError, Options<MvpApiCreateNewStorePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewStorePlanogramResponse, DefaultError, Options<MvpApiCreateNewStorePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateNewStorePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiGetStorePlanogramQueryKey = (options: Options<MvpApiGetStorePlanogramData>) => createQueryKey('mvpApiGetStorePlanogram', options);

/**
 * Get Store Planogram
 */
export const mvpApiGetStorePlanogramOptions = (options: Options<MvpApiGetStorePlanogramData>) => queryOptions<MvpApiGetStorePlanogramResponse, DefaultError, MvpApiGetStorePlanogramResponse, ReturnType<typeof mvpApiGetStorePlanogramQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetStorePlanogram({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetStorePlanogramQueryKey(options)
});

/**
 * Update Store Planogram
 */
export const mvpApiUpdateStorePlanogramMutation = (options?: Partial<Options<MvpApiUpdateStorePlanogramData>>): UseMutationOptions<MvpApiUpdateStorePlanogramResponse, DefaultError, Options<MvpApiUpdateStorePlanogramData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateStorePlanogramResponse, DefaultError, Options<MvpApiUpdateStorePlanogramData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateStorePlanogram({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListSuppliersQueryKey = (options?: Options<MvpApiListSuppliersData>) => createQueryKey('mvpApiListSuppliers', options);

/**
 * List Suppliers
 */
export const mvpApiListSuppliersOptions = (options?: Options<MvpApiListSuppliersData>) => queryOptions<MvpApiListSuppliersResponse, DefaultError, MvpApiListSuppliersResponse, ReturnType<typeof mvpApiListSuppliersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListSuppliers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListSuppliersQueryKey(options)
});

export const mvpApiListSuppliersInfiniteQueryKey = (options?: Options<MvpApiListSuppliersData>): QueryKey<Options<MvpApiListSuppliersData>> => createQueryKey('mvpApiListSuppliers', options, true);

/**
 * List Suppliers
 */
export const mvpApiListSuppliersInfiniteOptions = (options?: Options<MvpApiListSuppliersData>) => infiniteQueryOptions<MvpApiListSuppliersResponse, DefaultError, InfiniteData<MvpApiListSuppliersResponse>, QueryKey<Options<MvpApiListSuppliersData>>, number | Pick<QueryKey<Options<MvpApiListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListSuppliersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListSuppliers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListSuppliersInfiniteQueryKey(options)
});

/**
 * Create New Suppliers
 */
export const mvpApiCreateNewSuppliersMutation = (options?: Partial<Options<MvpApiCreateNewSuppliersData>>): UseMutationOptions<MvpApiCreateNewSuppliersResponse, DefaultError, Options<MvpApiCreateNewSuppliersData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewSuppliersResponse, DefaultError, Options<MvpApiCreateNewSuppliersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateNewSuppliers({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update Supplier
 */
export const mvpApiUpdateSupplierMutation = (options?: Partial<Options<MvpApiUpdateSupplierData>>): UseMutationOptions<MvpApiUpdateSupplierResponse, DefaultError, Options<MvpApiUpdateSupplierData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdateSupplierResponse, DefaultError, Options<MvpApiUpdateSupplierData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdateSupplier({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListRetailersQueryKey = (options?: Options<MvpApiListRetailersData>) => createQueryKey('mvpApiListRetailers', options);

/**
 * List Retailers
 */
export const mvpApiListRetailersOptions = (options?: Options<MvpApiListRetailersData>) => queryOptions<MvpApiListRetailersResponse, DefaultError, MvpApiListRetailersResponse, ReturnType<typeof mvpApiListRetailersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListRetailers({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListRetailersQueryKey(options)
});

export const mvpApiListRetailersInfiniteQueryKey = (options?: Options<MvpApiListRetailersData>): QueryKey<Options<MvpApiListRetailersData>> => createQueryKey('mvpApiListRetailers', options, true);

/**
 * List Retailers
 */
export const mvpApiListRetailersInfiniteOptions = (options?: Options<MvpApiListRetailersData>) => infiniteQueryOptions<MvpApiListRetailersResponse, DefaultError, InfiniteData<MvpApiListRetailersResponse>, QueryKey<Options<MvpApiListRetailersData>>, number | Pick<QueryKey<Options<MvpApiListRetailersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListRetailersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListRetailers({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListRetailersInfiniteQueryKey(options)
});

export const mvpApiGetRetailerQueryKey = (options: Options<MvpApiGetRetailerData>) => createQueryKey('mvpApiGetRetailer', options);

/**
 * Get Retailer
 */
export const mvpApiGetRetailerOptions = (options: Options<MvpApiGetRetailerData>) => queryOptions<MvpApiGetRetailerResponse, DefaultError, MvpApiGetRetailerResponse, ReturnType<typeof mvpApiGetRetailerQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetRetailer({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetRetailerQueryKey(options)
});

export const mvpApiListStoresQueryKey = (options?: Options<MvpApiListStoresData>) => createQueryKey('mvpApiListStores', options);

/**
 * List Stores
 */
export const mvpApiListStoresOptions = (options?: Options<MvpApiListStoresData>) => queryOptions<MvpApiListStoresResponse, DefaultError, MvpApiListStoresResponse, ReturnType<typeof mvpApiListStoresQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListStores({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStoresQueryKey(options)
});

export const mvpApiListStoresInfiniteQueryKey = (options?: Options<MvpApiListStoresData>): QueryKey<Options<MvpApiListStoresData>> => createQueryKey('mvpApiListStores', options, true);

/**
 * List Stores
 */
export const mvpApiListStoresInfiniteOptions = (options?: Options<MvpApiListStoresData>) => infiniteQueryOptions<MvpApiListStoresResponse, DefaultError, InfiniteData<MvpApiListStoresResponse>, QueryKey<Options<MvpApiListStoresData>>, number | Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListStoresData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListStores({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListStoresInfiniteQueryKey(options)
});

export const mvpApiGetStoreQueryKey = (options: Options<MvpApiGetStoreData>) => createQueryKey('mvpApiGetStore', options);

/**
 * Get Store
 */
export const mvpApiGetStoreOptions = (options: Options<MvpApiGetStoreData>) => queryOptions<MvpApiGetStoreResponse, DefaultError, MvpApiGetStoreResponse, ReturnType<typeof mvpApiGetStoreQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetStore({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetStoreQueryKey(options)
});

/**
 * Create Store Snapshot
 */
export const mvpApiCreateStoreSnapshotMutation = (options?: Partial<Options<MvpApiCreateStoreSnapshotData>>): UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateStoreSnapshotData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<MvpApiCreateStoreSnapshotData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateStoreSnapshot({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListPlanogramGroupsQueryKey = (options?: Options<MvpApiListPlanogramGroupsData>) => createQueryKey('mvpApiListPlanogramGroups', options);

/**
 * List Planogram Groups
 */
export const mvpApiListPlanogramGroupsOptions = (options?: Options<MvpApiListPlanogramGroupsData>) => queryOptions<MvpApiListPlanogramGroupsResponse, DefaultError, MvpApiListPlanogramGroupsResponse, ReturnType<typeof mvpApiListPlanogramGroupsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListPlanogramGroups({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramGroupsQueryKey(options)
});

export const mvpApiListPlanogramGroupsInfiniteQueryKey = (options?: Options<MvpApiListPlanogramGroupsData>): QueryKey<Options<MvpApiListPlanogramGroupsData>> => createQueryKey('mvpApiListPlanogramGroups', options, true);

/**
 * List Planogram Groups
 */
export const mvpApiListPlanogramGroupsInfiniteOptions = (options?: Options<MvpApiListPlanogramGroupsData>) => infiniteQueryOptions<MvpApiListPlanogramGroupsResponse, DefaultError, InfiniteData<MvpApiListPlanogramGroupsResponse>, QueryKey<Options<MvpApiListPlanogramGroupsData>>, number | Pick<QueryKey<Options<MvpApiListPlanogramGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListPlanogramGroupsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListPlanogramGroups({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramGroupsInfiniteQueryKey(options)
});

/**
 * Create New Planogram Group
 */
export const mvpApiCreateNewPlanogramGroupMutation = (options?: Partial<Options<MvpApiCreateNewPlanogramGroupData>>): UseMutationOptions<MvpApiCreateNewPlanogramGroupResponse, DefaultError, Options<MvpApiCreateNewPlanogramGroupData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateNewPlanogramGroupResponse, DefaultError, Options<MvpApiCreateNewPlanogramGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateNewPlanogramGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListPlanogramGroupsWithMissingProductImageCountQueryKey = (options?: Options<MvpApiListPlanogramGroupsWithMissingProductImageCountData>) => createQueryKey('mvpApiListPlanogramGroupsWithMissingProductImageCount', options);

/**
 * List Planogram Groups With Missing Product Image Count
 *
 * Get all planogram groups with their missing image counts in a single query.
 * Returns a list of dictionaries with id, name, missing_product_image_count, and total_product_count.
 *
 * [
 * { "id": "...", "name": "SKINCARE, DRY", "missing_product_image_count": 26, "total_product_count": 455 },
 * { "id": "...", "name": "HAIRCARE, COLOURS", "missing_product_image_count": 24, "total_product_count": 418 },
 * ...
 * ]
 */
export const mvpApiListPlanogramGroupsWithMissingProductImageCountOptions = (options?: Options<MvpApiListPlanogramGroupsWithMissingProductImageCountData>) => queryOptions<MvpApiListPlanogramGroupsWithMissingProductImageCountResponse, DefaultError, MvpApiListPlanogramGroupsWithMissingProductImageCountResponse, ReturnType<typeof mvpApiListPlanogramGroupsWithMissingProductImageCountQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListPlanogramGroupsWithMissingProductImageCount({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramGroupsWithMissingProductImageCountQueryKey(options)
});

export const mvpApiListPlanogramGroupCountsQueryKey = (options?: Options<MvpApiListPlanogramGroupCountsData>) => createQueryKey('mvpApiListPlanogramGroupCounts', options);

/**
 * List Planogram Group Counts
 *
 * Per planogram group: the unique-variant count and the distinct product count,
 * computed over only the latest planogram per (group, description).
 *
 * "Latest per description" matches what the Asset Admin Groups table already
 * shows for UNIQUE VARIANTS — superseded re-ingests of the same variant are
 * collapsed to their newest version. Summing per-variant product counts would
 * overcount heavily (products repeat across variants), so the distinct count is
 * taken across all latest variants at once.
 *
 * Deliberately its own endpoint, not a field on `/planogram-groups`: that list
 * has many callers that only need id -> name and shouldn't pay for this
 * aggregation over mvp_planogramproduct. Read-only, no migration.
 *
 * GET /v0/planogram-group-counts?retailer_id=<uuid|omitted>
 * -> [{ "id": "...", "name": "HAIRCARE, STYLING", "variant_count": 6, "product_count": 203 }]
 *
 * Groups with no planograms are omitted (nothing to count), matching the Groups
 * table, which hides zero-variant groups.
 */
export const mvpApiListPlanogramGroupCountsOptions = (options?: Options<MvpApiListPlanogramGroupCountsData>) => queryOptions<MvpApiListPlanogramGroupCountsResponse, DefaultError, MvpApiListPlanogramGroupCountsResponse, ReturnType<typeof mvpApiListPlanogramGroupCountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListPlanogramGroupCounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListPlanogramGroupCountsQueryKey(options)
});

export const mvpApiListUniquePlanogramGroupNamesQueryKey = (options?: Options<MvpApiListUniquePlanogramGroupNamesData>) => createQueryKey('mvpApiListUniquePlanogramGroupNames', options);

/**
 * List Unique Planogram Group Names
 */
export const mvpApiListUniquePlanogramGroupNamesOptions = (options?: Options<MvpApiListUniquePlanogramGroupNamesData>) => queryOptions<MvpApiListUniquePlanogramGroupNamesResponse, DefaultError, MvpApiListUniquePlanogramGroupNamesResponse, ReturnType<typeof mvpApiListUniquePlanogramGroupNamesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListUniquePlanogramGroupNames({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListUniquePlanogramGroupNamesQueryKey(options)
});

export const mvpApiGetPlanogramGroupQueryKey = (options: Options<MvpApiGetPlanogramGroupData>) => createQueryKey('mvpApiGetPlanogramGroup', options);

/**
 * Get Planogram Group
 */
export const mvpApiGetPlanogramGroupOptions = (options: Options<MvpApiGetPlanogramGroupData>) => queryOptions<MvpApiGetPlanogramGroupResponse, DefaultError, MvpApiGetPlanogramGroupResponse, ReturnType<typeof mvpApiGetPlanogramGroupQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiGetPlanogramGroup({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiGetPlanogramGroupQueryKey(options)
});

/**
 * Update Planogram Group
 */
export const mvpApiUpdatePlanogramGroupMutation = (options?: Partial<Options<MvpApiUpdatePlanogramGroupData>>): UseMutationOptions<MvpApiUpdatePlanogramGroupResponse, DefaultError, Options<MvpApiUpdatePlanogramGroupData>> => {
    const mutationOptions: UseMutationOptions<MvpApiUpdatePlanogramGroupResponse, DefaultError, Options<MvpApiUpdatePlanogramGroupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiUpdatePlanogramGroup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const mvpApiListProductImagesQueryKey = (options?: Options<MvpApiListProductImagesData>) => createQueryKey('mvpApiListProductImages', options);

/**
 * List Product Images
 */
export const mvpApiListProductImagesOptions = (options?: Options<MvpApiListProductImagesData>) => queryOptions<MvpApiListProductImagesResponse, DefaultError, MvpApiListProductImagesResponse, ReturnType<typeof mvpApiListProductImagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await mvpApiListProductImages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListProductImagesQueryKey(options)
});

export const mvpApiListProductImagesInfiniteQueryKey = (options?: Options<MvpApiListProductImagesData>): QueryKey<Options<MvpApiListProductImagesData>> => createQueryKey('mvpApiListProductImages', options, true);

/**
 * List Product Images
 */
export const mvpApiListProductImagesInfiniteOptions = (options?: Options<MvpApiListProductImagesData>) => infiniteQueryOptions<MvpApiListProductImagesResponse, DefaultError, InfiniteData<MvpApiListProductImagesResponse>, QueryKey<Options<MvpApiListProductImagesData>>, number | Pick<QueryKey<Options<MvpApiListProductImagesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
// @ts-ignore
{
    queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<QueryKey<Options<MvpApiListProductImagesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
            query: {
                page: pageParam
            }
        };
        const params = createInfiniteParams(queryKey, page);
        const { data } = await mvpApiListProductImages({
            ...options,
            ...params,
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: mvpApiListProductImagesInfiniteQueryKey(options)
});

/**
 * Create Product Issue
 */
export const mvpApiCreateProductIssueMutation = (options?: Partial<Options<MvpApiCreateProductIssueData>>): UseMutationOptions<MvpApiCreateProductIssueResponse, DefaultError, Options<MvpApiCreateProductIssueData>> => {
    const mutationOptions: UseMutationOptions<MvpApiCreateProductIssueResponse, DefaultError, Options<MvpApiCreateProductIssueData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await mvpApiCreateProductIssue({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
